<template>
    <section class="uik-nav-section__wrapper">
        <slot></slot>
    </section>
</template>

<script>
export default {
    name: "UikNavSection"
}
</script>

<style lang="scss">
.uik-nav-section__wrapper {
  & + & {
    margin-top: 20px;
  }
  &:last-child {
    margin-bottom: 20px;
  }
  &:first-child {
    margin-top: 15px;
  }
}
</style>
